// extracted by mini-css-extract-plugin
module.exports = {"inputFormContainer":"Diets_inputFormContainer__2bIFo","dietsContainter":"Diets_dietsContainter__17edF"};